import React, { useState } from "react";
import { DndContext } from "@dnd-kit/core";
import { SortableContext, arrayMove } from "@dnd-kit/sortable";
import { generateJobInterviewQns } from "../jobInterviewQnsUtil";
import { Button } from "reactstrap";
import { getLLResponse } from "@workspace/common/src/helpers/backend_helper";
import { toast } from "react-toastify";
import PreAssessmentQuestionInput from "./PreAssessmentQuestionInput/PreAssessmentQuestionInput";
import PreAssessmentSingleQn from "./PreAssessmentSingleQn/PreAssessmentSingleQn";
import { parseHtmlToText } from "../jobInterviewQnsUtil";

// Import uuidv4
import { v4 as uuidv4 } from "uuid";

const PreAssessmentQuestionList = ({
  jobDescription,
  handleSave,
  preAssessmentData,
  setPreAssessmentData,
}) => {
  //llmqa
  const [isLoading, setIsLoading] = useState(false);
  const [addExistingQns, setAddExistingQns] = useState(true);
  const [isPromptShowFlag, setIsPromptShowFlag] = useState(false);

  const handleGetAnswer = async (prompt) => {
    if (!prompt) {
      toast.error("Please enter a valid prompt");
      return;
    }

    if (!jobDescription) {
      toast.error("Please enter a valid job description");
      return;
    }

    const llmRequest = generateJobInterviewQns(
      prompt,
      parseHtmlToText(jobDescription),
      3,
      true,
      {
        setExistingQns: addExistingQns,
        field: "existing_interview_questions",
        existingInterviewQns: preAssessmentData?.questions || [],
      }
    );

    try {
      setIsLoading(true);
      const response = await getLLResponse(llmRequest);
      const interviewQuestions = response?.interviewQuestions;
      if (!interviewQuestions || interviewQuestions.length === 0) {
        toast.error(
          "Failed to generate questions. Please check job description and try again."
        );
        return;
      }

      const mappedInterviewQuestions = interviewQuestions?.map((question) => ({
        id: uuidv4(),
        question,
      }));

      setPreAssessmentData({
        ...preAssessmentData,
        questions: [
          ...preAssessmentData.questions,
          ...mappedInterviewQuestions,
        ],
      });
    } catch (error) {
      setIsLoading(false);
      toast.error("Failed to generate questions: " + error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddQuestion = () => {
    setPreAssessmentData({
      ...preAssessmentData,
      questions: [
        ...preAssessmentData.questions,
        { id: uuidv4(), question: "" },
      ],
    });
  };

  const handleDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;

    // Find the index of the active and over items by their ids
    const oldIndex = preAssessmentData.questions.findIndex(
      (item) => item.id === active.id
    );
    const newIndex = preAssessmentData.questions.findIndex(
      (item) => item.id === over.id
    );

    // Move the item to the new index
    const newQuestions = arrayMove(
      preAssessmentData?.questions,
      oldIndex,
      newIndex
    );

    setPreAssessmentData((prev) => ({
      ...prev,
      questions: newQuestions,
    }));
  };

  return (
    <div
      className="d-flex flex-column"
      style={{
        height: "100%",
      }}
    >
      <div className="d-flex align-items-center gap-2">
        {isPromptShowFlag && (
          <>
            <div className="flex-grow-1">
              <PreAssessmentQuestionInput
                onGetAnswer={handleGetAnswer}
                isLoading={isLoading}
                setQuestion={(value) => {
                  try {
                    setPreAssessmentData({
                      ...preAssessmentData,
                      prompt: value,
                    });
                  } catch (err) {}
                }}
                value={preAssessmentData?.prompt}
              />
            </div>
            <span
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid #0A4FAE",
                borderRadius: "50%",
                height: "40px",
                width: "40px",
              }}
              onClick={() => handleSave()}
            >
              <i className="fs-4 ri-save-3-line"></i>
            </span>{" "}
          </>
        )}
      </div>
      <div
        className="mb-2"
        style={{
          overflowY: "auto",
        }}
      >
        {preAssessmentData?.questions &&
          preAssessmentData?.questions.length > 0 && (
            <DndContext onDragEnd={handleDragEnd}>
              <SortableContext
                items={preAssessmentData?.questions?.map((item) => item.id)}
              >
                {preAssessmentData?.questions &&
                  preAssessmentData?.questions.length > 0 &&
                  preAssessmentData?.questions.map((question, index) => (
                    <div className="mt-2">
                      <PreAssessmentSingleQn
                        key={question?.id}
                        question={question}
                        onChange={(e) => {
                          const newQuestions = preAssessmentData.questions.map(
                            (item) => {
                              if (item.id === question.id) {
                                return {
                                  ...item,
                                  question: e.target.value,
                                };
                              }
                              return item;
                            }
                          );
                          setPreAssessmentData({
                            ...preAssessmentData,
                            questions: newQuestions,
                          });
                        }}
                        onDelete={() => {
                          const newQuestions =
                            preAssessmentData.questions.filter(
                              (item) => item.id !== question.id
                            );
                          setPreAssessmentData({
                            ...preAssessmentData,
                            questions: newQuestions,
                          });
                        }}
                      />
                    </div>
                  ))}
              </SortableContext>
            </DndContext>
          )}
      </div>
      <div className="d-flex align-items-center gap-3">
        <Button
          className="mt-2 flex-grow-1"
          onClick={handleAddQuestion}
          style={{
            backgroundColor: "#0A4FAE",
            color: "#fff",
          }}
        >
          + Add New
        </Button>

        <Button
          className="mt-2 flex-grow-1 btn btn-success"
          onClick={() => handleSave()}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default PreAssessmentQuestionList;
